import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
dayjs.locale('pt-br');

export default function BasicDatePicker({ id, value, onChange, label }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DemoContainer
        components={['DatePicker']}
        sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
      >
        <DatePicker
          label={label}
          format="DD/MM/YYYY"
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              size: 'small',
              sx: {
                height: 40,
                width: '100%',
                maxWidth: '400px',
                '.MuiInputBase-root': {
                  height: '100%',
                },
              },
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
